@if (tinymce.hasValue()) {
  <editor
    [id]="inputId()"
    [init]="config()"
    [disabled]="disabled()"
    licenseKey="gpl"
    (onInit)="instance.set($event.editor)"
  />
}
<p
  [id]="errorId()"
  aria-live="polite"
  class="tw-mt-1 tw-text-xs tw-text-danger-800"
>
  {{ errorMessage() }}
</p>
